// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"sn_a bhc_a bhc_r bhc_j","Photos__img":"sn_b bhc_b"};